module.exports = __webpack_public_path__ + "static/media/PickupFlatBedTruck.b2fce587.svg";